Vendd.Scripts.load(function () {

    var $page = $('.blog-list-page');
    var $wrapper = $('.x-article-list');

    if ($page.length <= 0 || $wrapper.length <=0 )
        return;

    var resize = false;
    var ww = $(window).outerWidth();
    var masonryState = false;
    var hasMasonry = $wrapper.data('masonry') === true;
    
    var $masonryTarget = $('.js-init-masonry', $wrapper);


    reorderBoxes();
    window.onload = function () {
        setTimeout(function () {
            window.scrollTo(0, 0);
        }, 0); }

    $( window ).on('resize', function() {
        ww = $(window).outerWidth();
        resize = true;
    })
    
    //sticky filters menu article check
    if ($(window).width() > 959) {
        blogStickyFilters();
    } else {
        changeLogoAfterScroll();
    }

    // Add an image load listener
    $("img", $masonryTarget).one("load", function () {
        if (masonryState == false){
            imagesLoaded();
        }
    }).each(function () {
        if (this.complete) {
            $(this).trigger('load');
        }
    });

    // Init masonry after images loaded
    function imagesLoaded() {
        destroyBlogMasonry($wrapper);
        initBlogMasonry($masonryTarget);
        masonryState = true;
    }

    //Sticky Filters - Blog list Page
    function blogStickyFilters() {

        var $siteCont = $('.site-container');

        var $container = $('.sticky-container', $page);

        var spacer = $('.content-spacer', $page);
        var filtersHeight = parseInt($('.second-half-content .sticky-container', $page).outerHeight());
        var footerFromTop = $('.footer-region').offset().top;
        var $menu = $('.header-template-one .menu-bar-icon');

        var lastScrollTop = 0;
        var delta = 1;

        //check if first load is on footer area
        if ($(window).scrollTop() >= (footerFromTop - 200)) {
            $container.addClass('hidden');
            $menu.removeClass('condensed');
        }
        //check if first load is in the middle
        if ($(window).scrollTop() < 25) {
            $siteCont.removeClass('blog-sticky');
        } else {
            $siteCont.addClass('blog-sticky');
        }

        if ($(window).scrollTop() < $('.main-article-list').offset().top - 70) {
            $container.removeClass('fixed');
            $menu.removeClass('condensed');
            spacer.height(0);
        } else {
            $container.addClass('fixed');
            $menu.addClass('condensed');
            spacer.height(filtersHeight);
        }

        //init function on scroll for menu articles.
        $(window).scroll(initSticky);

        function initSticky() {
            if ($(window).width() < 959)
                return;

            var scrollTop = $(window).scrollTop();

            //calculate again footer's distance from top
            var footerFromTop = $('.footer-region').offset().top;

            var st = $(this).scrollTop();
            // Make sure they scroll more than delta
            if (Math.abs(lastScrollTop - st) <= delta)
                return;

            if (scrollTop < 25) {
                $siteCont.removeClass('blog-sticky');
            } else {
                $siteCont.addClass('blog-sticky');
            }

            if (scrollTop < $('.main-article-list').offset().top - 70) {
                $container.removeClass('fixed');
                $menu.removeClass('condensed');
                spacer.height(0);
            } else {
                $container.addClass('fixed');
                $menu.addClass('condensed');
                spacer.height(filtersHeight);
            }

            //Hide Sticky container when scroll to footer
            if (scrollTop >= (footerFromTop - 200)) {
                $container.addClass('hidden');
                $menu.removeClass('condensed');
            } else {
                $container.removeClass('hidden');
                if ($container.hasClass('fixed')) {
                    $menu.addClass('condensed');
                } else {
                    $menu.removeClass('condensed');
                }
            }

            lastScrollTop = st;
        }

    }

    function reorderBoxes() {

        if (isTouch()) {
            $(window).resize(function () {
                attachToCanvasMenu();
            });
        }

        var isMoved = false;

        if ($(window).width() < 960) {
            if (isTouch()) {
                if ($('.tagged-articles', $page).length > 0)
                    $('.tagged-articles', $page).detach().appendTo('.main-content').show();

                if ($('.social-follow-container', $page).length > 0)
                    $('.social-follow-container', $page).detach().appendTo('.main-content').show();
                isMoved = true;
            }
        }

        function attachToCanvasMenu() {

            if ($(window).width() < 960) {
                if (!isMoved) {
                    if ($('.tagged-articles', $page).length > 0)
                        $('.tagged-articles', $page).detach().appendTo('.main-content').show();

                    if ($('.social-follow-container', $page).length > 0)
                        $('.social-follow-container', $page).detach().appendTo('.main-content').show();
                    isMoved = true;
                }
            } else {
                if (isMoved) {
                    if ($('.tagged-articles', $page).length > 0)
                        $('.tagged-articles', $page).detach().appendTo('.side-content').show();

                    if ($('.social-follow-container', $page).length > 0)
                        $('.social-follow-container', $page).detach().appendTo('.side-content').show();

                    isMoved = false;
                }
            }
        }

    }

    function changeLogoAfterScroll() {

        var topHeight = $('.first-half-content').height();
        var $topSection = $('.js-first-section');

        // change header logo to withoutText, after scroll more than first-half-content height
        if ($(window).scrollTop() > topHeight) {
            addLogoType(false);
        } else {
            addLogoType(true);
        }

        // init function on scroll
        $(window).scroll(initChangeLogoAfterScroll);

        function initChangeLogoAfterScroll() {
            if ($(window).scrollTop() > topHeight) {
                addLogoType(false);
            } else {
                addLogoType(true);
            }
        }

        function addLogoType(opt) {
            $topSection.data('with-text', opt);
        }

    }
});

function destroyBlogMasonry(wrapper) {
    var $getTheLookList = $('> ul', wrapper);

    if ($getTheLookList.hasClass('masonry-initiliazed')) {
        //destroy masonry before re-init
        $getTheLookList.masonry('destroy');
        $getTheLookList.removeClass('masonry-initiliazed')
    }
};

function initBlogMasonry(masonryTarget) {
    if (!masonryTarget.hasClass('masonry-initiliazed')) {
        //init masonry only if images are loaded
        masonryTarget.imagesLoaded(function () {
            masonryTarget.masonry({
                itemSelector: '.masonry-item',
                columnWidth: '.masonry-grid-sizer',
                gutter: '.masonry-gutter-size',
                transitionDuration: 0
            });
        }); 
        var lastPage = masonryTarget.children('li').last().attr('data-page');
        masonryTarget.on('layoutComplete', function () { $('html, body').animate({ scrollTop: masonryTarget.children('li[data-page=' + lastPage + ']').first().offset().top - $('.second-half-content .sticky-container').outerHeight() }, 1) });
        $('>.masonry-item', masonryTarget).addClass('shown');
        masonryTarget.addClass('masonry-initiliazed');
    }
}